import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { Identity } from '@ducat-pro-wallets/swag-wallet';
import { provideValueAccessor } from '@s-libs/ng-core';
import { combineLatest } from 'rxjs';
import { map, share } from 'rxjs/operators';

import { IdentitiesService } from '@dsh/api/wallet';
import { FilterSuperclass } from '@dsh/components/filter';

@Component({
    selector: 'dsh-identity-filter',
    templateUrl: 'identity-filter.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [provideValueAccessor(IdentityFilterComponent)],
})
export class IdentityFilterComponent extends FilterSuperclass<Identity['id']> {
    identity$ = combineLatest([this.identitiesService.identities$, this.savedValue$]).pipe(
        map(([identities, value]) => identities.find((i) => i.id === value)),
        share()
    );

    constructor(injector: Injector, private identitiesService: IdentitiesService) {
        super(injector);
    }
}
